document.addEventListener("DOMContentLoaded", function () {
  const logoContainer = document.getElementById("animated-logo-container");
  const animatedLogoDiv = document.getElementById("animated-logo"); // Renamed for clarity as it's the div
  const logoImg = animatedLogoDiv ? animatedLogoDiv.querySelector("img") : null; // Get the img tag inside

  // Early exit if essential elements are not found
  if (!logoContainer || !animatedLogoDiv || !logoImg) {
    console.warn(
      "One or more logo elements were not found. Animation might not work correctly."
    );
    return;
  }

  const initialTop = parseInt(window.getComputedStyle(logoContainer).top);
  const finalTop = window.innerWidth < 767 ? -9 : -7; // Final top position in pixels
  const scrollThreshold = 75; // Changed to 75px threshold

  function vwToPx(vw) {
    return (vw * window.innerWidth) / 100;
  }

  function animateLogo() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const finalWidthPx = window.innerWidth < 767 ? 145 : 187;
    const verticalOffset = window.innerWidth < 767 ? -4 : 0;
    const initialWidthVw = window.innerWidth < 767 ? 50 : 27;
    const initialWidthPx = vwToPx(initialWidthVw);

    if (scrollTop > scrollThreshold) {
      logoContainer.style.top = `${finalTop - verticalOffset}px`;
      animatedLogoDiv.style.width = `${finalWidthPx}px`;
      logoImg.classList.add("original-color"); // Remove invert
    } else {
      logoContainer.style.top = `${initialTop}px`;
      animatedLogoDiv.style.width = `${initialWidthPx}px`;
      logoImg.classList.remove("original-color"); // Add invert (by removing the class that disables it)
    }
  }

  window.addEventListener("scroll", animateLogo);
  window.addEventListener("resize", () => {
    // Recalculate initialTop on resize as it might change due to responsive CSS
    // Or simply re-run animateLogo which handles the current state
    // For simplicity, just calling animateLogo should adjust based on new dimensions
    animateLogo();
  });

  animateLogo(); // Call once on load to set initial state
});
